import { Component, input, output } from '@angular/core';
import type { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-feedback-filter',
  imports: [],
  templateUrl: './feedback-filter.component.html',
  styleUrl: './feedback-filter.component.css',
})
export class FeedbackFilterComponent {
  public colDefs = input.required<ColDef[]>();
  public columnUpdate = output<{ visible: boolean; field: string }>();

  protected toggleColumn(field: string | undefined, event: Event) {
    if (!field) return;

    const visible = (event.target as HTMLInputElement).checked;
    this.columnUpdate.emit({ visible, field });
  }
}
